var styles = {"box":"FileUploader_box_sftl2_1","simple-view":"FileUploader_simple-view_sftl2_6","area":"FileUploader_area_sftl2_6","info":"FileUploader_info_sftl2_10","simple-button":"FileUploader_simple-button_sftl2_13","error":"FileUploader_error_sftl2_44","description":"FileUploader_description_sftl2_47","drag-on":"FileUploader_drag-on_sftl2_50"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
